export default __webpack_public_path__ + "static/media/DSC_7491.c77384be.jpg";